import { Flex, Spinner } from '@chakra-ui/react'

// Loading component
export default function Loading({ w, h }) {
    return(
        <Flex w={w} h={h} direction='row' align='center' justify='center' pt={5} pb={2} pl={8} bgColor='#efe8d8'>
            <Spinner size='xl' thickness='4px' color='#222f467a' />
        </Flex>
    );
}